import { gql } from '@apollo/client';

import { GqlSimpleTag } from './tag';

export interface GqlProgram {
  id: number;
  ageDemographic: string;
  description: string;
  isCoed: boolean;
  name: string;
  organizationId: number;
  sportId: number;
  type: string;
}

export const GqlProgramFragment = gql`
  fragment ProgramFields on Program {
    __typename
    id
    ageDemographic
    description
    isCoed
    name
    organizationId
    sportId
  }
`;

interface Attributes {
  areaOfOperation: GqlSimpleTag;
  ageDivisions: GqlSimpleTag[];
  competitionGenders: GqlSimpleTag[];
  competitionLevels: GqlSimpleTag[];
}

export type GqlProgramExpanded = GqlProgram & Attributes

export const GqlProgramFragmentExpanded = gql`
  fragment ProgramFieldsExtended on Program {
    __typename
    id
    ageDemographic
    description
    isCoed
    name
    organizationId
    sportId
    type
    areaOfOperation {
      id
      name
    }
    ageDivisions {
      id
      name
    }
    competitionGenders {
      id
      name
    }
    competitionLevels {
      id
      name
    }
  }
`;

export const GqlProgramWithSeasonsFragment = gql`
  fragment ProgramWithSeasons on Program {
    id
    name
    seasons(filter: { isArchived: null }) {
      id
      name
      tsDivisionId
      isArchived
    }
  }
`;

export const GqlProgramSeasonsWithDivisionsFragment = gql`
  fragment ProgramSeasonWithDivisions on Program {
    id
    name
    seasons(filter: { isArchived: null }) {
      id
      name
      tsDivisionId
      isArchived
      defaultPaymentAccountId
      divisions {
        id
        name
      }
      teams {
        id
        name
      }
    }
  }
`;
